import service from '../../index2';
export function Page(data) {
  return service({
    method: 'get',
    url: '/api2/apiServer/product',
    params: {
      action: 'searchProduct',
      ...data,
    },
  });
}
